export default __webpack_public_path__ + "static/media/Malawi.7e49b7d7.png";